import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "drawer-container"
};
import ThemePicker from './ThemePicker.vue';
import useStore from '@/store';
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Setting',
  setup: function setup(__props) {
    var store = useStore();
    var visible = ref(false);
    var theme = ref(store.setting.theme);
    var setting = useStore().setting;
    var tagsView = ref(setting.tagsView);
    var sidebarLogo = ref(setting.sidebarLogo);
    var appNode = document.getElementById('app');
    var themeChange = function themeChange(val) {
      setting.changeSetting({
        theme: val
      });
      appNode === null || appNode === void 0 || appNode.style.setProperty('--menu-background-color', val);
    };
    function handleClose() {
      visible.value = false;
    }
    function handleOpen() {
      visible.value = true;
    }
    return function (_ctx, _cache) {
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_switch = _resolveComponent("el-switch");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_drawer = _resolveComponent("el-drawer");
      var _component_IEpSetting = _resolveComponent("IEpSetting");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_drawer, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return visible.value = $event;
        }),
        title: "系统设置",
        "before-close": handleClose
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form, {
            "label-position": "right",
            "label-width": "100px",
            style: {
              "max-width": "460px"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                label: "主题颜色"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(ThemePicker, {
                    modelValue: theme.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return theme.value = $event;
                    }),
                    type: "theme",
                    onChange: themeChange
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "导航标签"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_switch, {
                    modelValue: tagsView.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return tagsView.value = $event;
                    }),
                    class: "drawer-switch"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "LOGO"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_switch, {
                    modelValue: sidebarLogo.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return sidebarLogo.value = $event;
                    }),
                    class: "drawer-switch"
                  }, null, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", {
        class: "setting-btn",
        onClick: handleOpen
      }, [_createVNode(_component_IEpSetting)], 512), [[_vShow, !visible.value]])]);
    };
  }
});